"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsuranceClaimAttachmentFileType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var InsuranceClaimAttachmentFileType_Factory = /** @class */ (function () {
    function InsuranceClaimAttachmentFileType_Factory() {
    }
    InsuranceClaimAttachmentFileType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    InsuranceClaimAttachmentFileType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return InsuranceClaimAttachmentFileType_Factory;
}());
exports.InsuranceClaimAttachmentFileType_Factory = InsuranceClaimAttachmentFileType_Factory;
